export const mockCaseListProps = {
  entryView: 'CaseList' as const,
  onFilteredCaseCountChange: (caseNumber: number) => {
    console.log('onFilteredCaseCountChange', caseNumber);
  },
  preSelectedCategory: 'fbb03a4d-6e14-4f84-ab01-5ed556db456b',
  entityMap: new Map([['BOOKING', 'AL0-SWJPPQPWW7A7W']]),
  caseSearchParams: {
    caseFilter: {
      field: {
        quantifier: 'EQUAL',
        field: 'ENTITY_ID',
        value: 'AL0-SWJPPQPWW7A7W',
      },
    },
    pageSize: 10,
    pageNumber: 1,
    embed: ['sla', 'participants', 'readStatus', 'targetPartyType'],
  },
  onBookingAutoSuggestFunction: () =>
    Promise.resolve([
      { entityId: 'AL0-SWJPPQPWW7A7W', shipperId: 'TNUZAKQWGMPQQ' },
    ]),
  onVesselAutoSuggestFunction: () =>
    Promise.resolve(['EVER FAME', 'ONE FALCON']),
  onClaimAutoSuggestFunction: () => Promise.resolve(['claim-001', 'claim-002']),
  onShipperAutoSuggestFunction: () =>
    Promise.resolve([
      {
        shipperId: 'TNUZAKQWGMPQQ',
        shipperName: 'TNUZAKQWGMPQQ',
        isOnboard: false,
      },
    ]),
  onGetLspRoleGroupAndMemberFunction: (bookingId: string, lspType: string) => {
    if (lspType === 'DROP_OFF_LSP') {
      return Promise.resolve([
        { memberId: 'testLspRole', roleGroup: 'testLspRole' },
      ]);
    }
    return Promise.resolve([]);
  },
  onOperatorAutoSuggestFunction: () =>
    Promise.resolve({
      AMS_FILING_OPERATOR: 'liuson5T',
      BILLING_OPERATOR: 'liuson7T',
    }),
  onGetContainerInfosByBookingIdFunction: () =>
    Promise.resolve([
      {
        shipperId: 'seller1',
        containerNumber: 'CONT001',
        containerId: 'CONT001',
      },
    ]),
};

export const mockCaseDetailsProps = {
  entryView: 'CaseDetails' as const,
  caseId: '',
  onGetRoleGroupCompanyCodeByMemberFunction: () => Promise.resolve('code12'),
  onCheckTransferOwnerLogin: (userId: string) => {
    return Promise.resolve(['wenxuanf', 'twanyife'].includes(userId));
  },
  onGetRoleGroupListFunction: () =>
    Promise.resolve([
      { roleGroupId: 'testRoleGroupId', roleGroupName: 'testRoleGroupName' },
    ]),
  onGetMemberFromRoleGroupFunction: (roleGroupId: string) => {
    const memberMap: Record<string, string> = {
      'Role-Group-id1': 'role-group-1-ops',
      'Role-Group-id2': 'role-group-2-ops',
    };
    return Promise.resolve(memberMap[roleGroupId] || 'default-ops');
  },
  onShipperAutoSuggestFunction: () =>
    Promise.resolve([
      {
        shipperId: 'TNUZAKQWGMPQQ',
        shipperName: 'TNUZAKQWGMPQQ',
        isOnboard: false,
      },
    ]),
  onCheckInviteParticipantLogin: (userId: string) =>
    Promise.resolve(userId === 'chenjt'),
  onOperatorAutoSuggestFunction: () =>
    Promise.resolve({
      AMS_FILING_OPERATOR: 'liuson5T',
      BILLING_OPERATOR: 'liuson7T',
    }),
};

export const mockCreateCaseProps = {
  entryView: 'CreateCase' as const,
  preSelectedCategory: 'fbb03a4d-6e14-4f84-ab01-5ed556db456b',
  entityMap: new Map([['BOOKING', 'AL0-SWJPPQPWW7A7W']]),
  taskId: 'test task id',
  visible: false,
  setShowModal: () => {}, // eslint-disable-line @typescript-eslint/no-empty-function
  onVesselAutoSuggestFunction: () =>
    Promise.resolve(['EVER FAME', 'ONE FALCON']),
  onClaimAutoSuggestFunction: () => Promise.resolve(['claim-001', 'claim-002']),
  onShipperAutoSuggestFunction: () =>
    Promise.resolve([
      {
        shipperId: 'TNUZAKQWGMPQQ',
        shipperName: 'TNUZAKQWGMPQQ',
        isOnboard: false,
      },
    ]),
  onGetLspRoleGroupAndMemberFunction: (bookingId: string, lspType: string) => {
    if (lspType === 'DROP_OFF_LSP') {
      return Promise.resolve([
        { memberId: 'testLspRole', roleGroup: 'testLspRole' },
      ]);
    }
    return Promise.resolve([]);
  },
  onOperatorAutoSuggestFunction: () =>
    Promise.resolve({
      AMS_FILING_OPERATOR: 'liuson5T',
      BILLING_OPERATOR: 'liuson7T',
    }),
  onGetContainerInfosByBookingIdFunction: () =>
    Promise.resolve([{ containerNumber: 'CONT001', containerId: 'CONT001' }]),
};

export const mockTaskListDetails = (
  taskIds?: string[],
  bookingIds?: string[],
) => {
  if (taskIds && taskIds.length > 0) {
    const records = taskIds.map((taskId) => ({
      taskId,
      taskName: `taskName_${taskId}`,
      taskStatus: 'open',
      eta: 1564502399000,
    }));
    return Promise.resolve(records);
  }
  if (bookingIds && bookingIds.length > 0) {
    return Promise.resolve([
      {
        taskId: 'taskId1',
        taskName: 'taskName1',
        taskStatus: 'open',
        eta: 1564502399000,
      },
      {
        taskId: 'taskId2',
        taskName: 'taskName2',
        taskStatus: 'open',
        eta: 1564502399000,
      },
    ]);
  }
  return Promise.resolve([]);
};
